"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTableButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsButton = require("../DmsButton/DmsButton");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * DmsTableButton component provides a button that handles a DmsTable row.
 * @param {Object} props - Component properties.
 * @param {Object} props.table - Table that will be handled.
 * @param {React.ReactNode} props.children - Children that will be added inside the button.
 * @param {string} props.variant - Bootstrap variant of the component (primary, secondary, success, danger, warning, info, light, or dark).
 * @param {string} props.text - Text that will be shown to the user.
 * @param {JSX.Element} props.icon - Icon that will be shown to the user.
 * @param {function} props.onClick - Function that will be called when the user clicks on the button, it will be supplied with filtered and original data.
 * @param {string} props.label - Label that will be shown used for the button.
 * @param {boolean} props.disabled - If the button is disabled or not.
 * @param {boolean} props.outline - If the button is an outline button or not.
 * @param {boolean} props.iconFirst - If the icon should be placed before the text or not.
 * @param {function|string|Array} props.filter - Filter that will be used to filter the data.
 * @param {Array|string} props.columns - Columns that will be used to filter the data.
 * @param {boolean} props.replaceNull - If the null values should be replaced with empty strings or not.
 * @returns {JSX.Element} The DmsTableButton component.
 */
const DmsTableButton = props => {
  let handler = props["onClick"];
  let columns = props["columns"];
  const handleClick = async e => {
    var _props$table;
    e.preventDefault();
    let currentTarget = e.target;
    while (currentTarget) {
      if (currentTarget.tagName === 'TR') {
        let rowElement = currentTarget;
        break;
      }
      currentTarget = currentTarget.parentNode;
    }
    const currentLine = currentTarget;
    const id = currentLine === null || currentLine === void 0 ? void 0 : currentLine.getAttribute('data-id');
    let data = null;
    if (props.table && props.table.current && props.table.current.getRowData && id != null) {
      data = props.table.current.getRowData(id);
    } else {
      data = e.currentTarget.parentNode.dataset.bind;
    }
    let originalData = _objectSpread({}, data);
    if (columns && !props.filter) {
      if (typeof columns === 'string') columns = [columns];
      let filtered_data = {};
      for (let key in data) {
        if (columns.includes(key)) {
          filtered_data[key] = data[key];
        }
      }
      data = filtered_data;
    } else if (props.filter) {
      let filtered_data = {};
      for (let key in data) {
        if (props.filter(key)) {
          filtered_data[key] = data[key];
        }
      }
      data = filtered_data;
    }
    if (props.replaceNull) {
      for (let key in data) {
        if (!data[key]) {
          data[key] = "";
        }
      }
    }
    if ((_props$table = props.table) !== null && _props$table !== void 0 && (_props$table = _props$table.current) !== null && _props$table !== void 0 && _props$table.getHeader && data && Object.keys(data).length > 0) {
      const header = props.table.current.getHeader();
      header.forEach(item => {
        if (item.can_edit !== false) {
          var _item$properties;
          const key = item.column_name;
          if (item !== null && item !== void 0 && (_item$properties = item.properties) !== null && _item$properties !== void 0 && _item$properties.value) {
            if (Array.isArray(data[key])) {
              data[key] = data[key].map(dataKey => {
                return dataKey && dataKey[item.properties.value] !== undefined ? dataKey[item.properties.value] : "";
              });
            } else if (data && data[key] && data[key][item.properties.value] !== undefined) {
              data[key] = data[key][item.properties.value];
            }
          }
        }
      });
    }
    if (handler) handler(e, data, originalData);
  };
  return /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, _extends({}, props, {
    onClick: handleClick
  }));
};
exports.DmsTableButton = DmsTableButton;